import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f270300"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3f270300&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f270300')) {
      api.createRecord('3f270300', component.options)
    } else {
      api.reload('3f270300', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f270300", function () {
      api.rerender('3f270300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/etc/index.vue"
export default component.exports